import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchGatepassList = createAsyncThunk(
	"fetchGatepassList",
	async ({ page = 1, limit = 10, start_date, end_date, gatepass_user }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.get(
				`gatepass/getall?page=${page}&limit=${limit}&start_date=${start_date}&end_date=${end_date}&gatepass_user=${gatepass_user}`
			);
			return response.data;
		} catch (err) {
			if (!err.response) throw err;
			return rejectWithValue(err.response.data);
		}
	}
);

const GatepassListSlice = createSlice({
	name: "GatepassListSlice",
	initialState: {
		isLoading: false,
		data: [],
		error: null,
		page: 1,
		total: 0,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchGatepassList.pending, (state) => {
			state.isLoading = true;
			state.error = null;
		});
		builder.addCase(fetchGatepassList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload?.data || [];
			state.page = action.payload?.pagination?.page || 1;
			state.total = action.payload?.pagination?.total || 0;
		});
		builder.addCase(fetchGatepassList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default GatepassListSlice.reducer;
